import { useContext } from "react"
import { CollapseContext } from "context/CollapseContext"

const useCollapse = () => useContext(CollapseContext)

export default useCollapse
